<template>
  <div
    class="alert-box"
    :class="{
      error: type == 'error',
      success: type == 'success',
      alert: type == 'alert',
    }"
    :position="pos"
    v-if="show"
  >
    <svg class="svg-icons" v-if="type == 'error'">
      <use
        :xlink:href="require('@/assets/img/icons/alert-circle.svg') + '#layer'"
      ></use>
    </svg>
    <svg class="svg-icons" v-if="type == 'success'">
      <use
        :xlink:href="
          require('@/assets/img/icons/checkbox-marked-circle.svg') + '#layer'
        "
      ></use>
    </svg>
    <svg class="svg-icons" v-if="type == 'alert'">
      <use
        :xlink:href="require('@/assets/img/icons/alert.svg') + '#layer'"
      ></use>
    </svg>

    <p v-html="alertType + (onDict ? getT(message) : message)"></p>

    <div class="close-button" @click="kill()">
      <p>x</p>
    </div>
  </div>
</template>

<script>
export default {
  // Tipos de alertas: error, success, alert
  props: {
    type: { default: "alert" },
    message: { default: "Algum erro ocorreu." },
    time: { default: 1 },
    transition: { default: false },
    pos: { default: 0 },
    onDict: { default: true },
  },
  inject: {
    container: {
      default() {
        console.error(
          "AlertMessage deve ser filho de um container de mensagens"
        );
      },
    },
  },
  data() {
    return {
      alertType: "",
      show: true,
    };
  },
  mounted() {
    if (!this.type || this.type == "alert") {
      this.alertType = this.$t("alerta");
    } else if (this.type == "error") {
      this.alertType = this.$t("erro");
    } else if (this.type == "success") {
      this.alertType = this.$t("sucesso");
    } else {
      this.type = "alert";
      this.alertType = this.$t("alerta");
    }

    if (this.transition) {
      setTimeout(
        this.kill,
        this.time * 1000 + this.pos * 200 + Math.random() * 100
      );
    }
  },
  methods: {
    kill() {
      let s = this.container.messages.splice(this.pos, 1);
      if (!s.length) {
        let msg = this.container.messages.filter(
          (m) => m.message == this.message
        )[0];
        if (msg) {
          let iMsg = this.container.messages.indexOf(msg);
          this.container.messages.splice(iMsg, 1);
        }
      }
    },
  },
};
</script>

<style lang="scss">
.alert-box {
  strong {
    color: $sovis-white;
  }
}
</style>

<style lang="scss" scoped>
.alert-box {
  width: 100%;
  max-width: 100%; /* antes era 850px — agora respeita o container de 300px */
  margin-bottom: 10px;
  border-radius: 10px;
  display: flex;
  align-items: flex-start; /* permite texto em múltiplas linhas */
  justify-content: space-between;
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
  z-index: 10000;

  &.error {
    background: $red-alert;
  }
  &.success {
    background: $green-alert;
  }
  &.alert {
    background: $orange-alert;
  }

  .svg-icons {
    fill: $sovis-white;
    flex: 0 0 auto;
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }

  p {
    font-size: 14px;
    line-height: 17px;
    text-align: left;
    letter-spacing: 0.26px;
    font-weight: 600;
    color: $sovis-white;
    flex: 1 1 auto;
    min-width: 0; /* evita overflow dentro do flex */
    margin: 0; /* remove o margin:auto que causava desalinhamento */

    /* 🔥 resolve o problema do texto longo */
    white-space: normal;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .close-button {
    background: rgba(57, 57, 57, 0.4);
    flex: 0 0 auto;
    height: 40px;
    width: 40px;
    border-radius: 20px;
    position: relative;
    margin-left: 15px;

    > p {
      font-size: 30px;
      color: $sovis-white;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      text-align: center;
      cursor: pointer;
      user-select: none;
      z-index: 1;
    }
  }
}

/* animações */
@mixin hiddenMessage() {
  opacity: 0 !important;
}

@mixin transitionMultiMessage($duration) {
  transition-timing-function: ease-in;
  transition: all $duration;
}

.message-enter-active,
.message-leave-active {
  @include transitionMultiMessage(0.5s);
}

.message-enter,
.message-leave-to {
  @include hiddenMessage();
}
</style>
